import React, { useState } from 'react';
import { Card } from '@repo/ui/Card';
import { useNavigate } from 'react-router';
import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import { Button } from '@repo/ui/Button';
import { useZodForm } from '@repo/hooks/useZodForm';

import { DeleteDialog } from '@repo/ui/Dialog';
import { Form } from '@repo/ui/Form';
import type { Mercury } from '@repo/types/Models';

export interface DeleteUserProps {
  first_name: Mercury.Models.User['first_name'];
  last_name: Mercury.Models.User['last_name'];
  email: Mercury.Models.User['email'];
  loading: boolean;
  userId: Mercury.Models.User['id'];
  accountId: string | string[] | undefined;
}

const DeleteUser = ({
  first_name,
  last_name,
  email,
  userId,
  loading,
  accountId,
}: DeleteUserProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const DELETE_USER = gql`
    mutation DeleteUser($id: ID!) {
      deleteUser(id: $id) {
        user {
          id
        }
      }
    }
  `;

  const client = useApolloClient();
  const onSubmit = async () => {
    setIsOpen(false);
    await client.mutate({
      mutation: DELETE_USER,
      variables: {
        id: userId,
      },
    });
    setTimeout(() => {
      navigate(`/a/${accountId}/users`);
    }, 2000);
  };

  const form = useZodForm({
    onSubmit,
  });

  return (
    <>
      <Card title="Delete user">
        <Button loading={loading} variant="danger" onClick={() => setIsOpen(true)}>
          Delete user {first_name} {last_name}
        </Button>
      </Card>

      <DeleteDialog
        title={`Are you sure you want to delete this user?`}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        centered
        form={form}
        submitText="Yes, delete user"
        cancelText="No, abort"
      >
        <Form.Success>User successfully deleted</Form.Success>
        <Form.Error>
          Unable to delete user. Please try again later or contact support if error persists.
        </Form.Error>
        <div className=" col-span-2 flex flex-col items-center w-full gap-2 py-3 border border-l-0 border-r-0 mb-7 border-grey-400/50">
          <span className="text-2xl font-bold">
            {first_name} {last_name}
          </span>
          <span>ID: {userId}</span>
          <span>Email: {email}</span>
        </div>
      </DeleteDialog>
    </>
  );
};

export default DeleteUser;
